import { useMemo } from "react";
import { StoreMetadata } from "../types";
import { resizeImage as resizeImageFn } from "../util/image";
import { WEB_ASSETS } from "../constants";

export const useStoreImages = (storeMetadata?: StoreMetadata) => {
  const avatarProfileDefault = `${WEB_ASSETS}/cute_logo.webp`;

  const resizeImage = (link: string, width: number, height: number) => {
    if (link?.includes(".svg")) return link;
    return link.indexOf("cute_logo") >= 0
      ? avatarProfileDefault
      : resizeImageFn(link, width, height, 80);
  };
  const storeSquareImage = useMemo(() => {
    return storeMetadata?.profilePicConfiguration?.enableSquare
      ? resizeImage(
          storeMetadata?.profilePicConfiguration?.squareImage || "",
          64,
          64,
        )
      : null;
  }, [storeMetadata]);
  const storeRectangleImage = useMemo(() => {
    return storeMetadata?.profilePicConfiguration?.enableRectangle
      ? resizeImage(
          storeMetadata?.profilePicConfiguration?.rectangleImage || "",
          120,
          64,
        )
      : null;
  }, [storeMetadata]);

  const partnerProfilePicture = useMemo(() => {
    return (
      storeSquareImage ||
      storeRectangleImage ||
      storeMetadata?.profilePic ||
      avatarProfileDefault
    );
  }, [storeSquareImage, storeRectangleImage]);

  return {
    partnerProfilePicture,
  };
};
